import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import FormHandler from 'AdminApp/common/script/services/crud/FormHandler';
import FormComponent from 'AdminApp/common/script/components/crud/FormComponent';
import ModalDialog from 'AdminApp/elements/modal/ModalDialog';

export default class FormSubmitWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfoModal: false,
      infoMessage: false
    }
    // Initial state
    this.formHandler = props.formHandler;

    this.formHandler.on('submitSuccess', (data) => {
      let customMessage = this.props.getModalMessage(data);
      this.setState({
        showInfoModal: true,
        infoMessage: true,
        textMessage: customMessage || data.message || 'The form is successfully saved.'
      })

      if(props.onSuccess) {
        props.onSuccess();
        this.setState({
          showInfoModal: false,
        })
      } else {
        setTimeout(() => {
          this.setState({
            showInfoModal: false,
            redirect: true
          })
        }, 3000);
      }
    })

    this.formHandler.on('submitError', (error) => {
      let data = error.responseJSON ? error.responseJSON : error;
      let customMessage = this.props.getModalMessage(data);
      this.setState({
        showInfoModal: true,
        infoMessage: false,
        textMessage: customMessage || data.message || 'Oops, something is wrong, you can not finish this action.'
      })
      setTimeout(() => {
        this.setState({
          showInfoModal: false,
        })
      }, 3000);
    })
  }


  onClose() {
    this.setState({
      showInfoModal: false
    })
  }

  render() {
    if (this.state.redirect && this.props.to) {
      return <Redirect to={this.props.to}></Redirect>
    }


    let formHandler = this.formHandler;

    let successMessage = <div style={{ display: 'flex' }}>
      <p style={{ textAlign: 'center' }}>{this.state.textMessage}</p>
      <i className="fa fa-check" aria-hidden="true" style={{ color: 'rgba(86, 181, 66, 0.8)', fontSize: 24, paddingLeft: 20 }}></i>
    </div>

    let errorMessage = <div style={{ display: 'flex' }}>
      <p style={{ textAlign: 'center' }}>{this.state.textMessage}</p>
      <i className="fa fa-times" aria-hidden="true" style={{ color: 'red', fontSize: 24, paddingLeft: 20 }}></i>
    </div>

    let cancelBtn = <Link to={this.props.to} className='cancelBtn'>Cancel</Link>

    return (
      <div>

        <FormComponent formHandler={formHandler}>
          {this.props.children}

          <div className='formRow' style={{ marginTop: 20, display: 'flex', alignItems: 'center' }}>
            <button type="submit" onClick={(e) => this.formHandler.handleSubmit(e)}>{this.props.buttonText}</button>
            {this.props.showBtn === true ? cancelBtn : null}
          </div>
        </FormComponent>

        <ModalDialog show={this.state.showInfoModal} onClose={this.onClose.bind(this)} shouldCloseOnOverlayClick={false} shouldCloseOnEsc={false}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {this.state.infoMessage === true ? successMessage : errorMessage}
          </div>
        </ModalDialog>
      </div>
    );
  }
}

FormSubmitWrapper.defaultProps = {
  buttonText: 'Save',
  getModalMessage: () => null,
  showBtn: true
};



// WEBPACK FOOTER //
// ./src/common/script/components/crud/FormSubmitWrapper.js